import fileSaver from 'file-saver'
import * as XLSX from 'xlsx'
import axios from '../../../../apis/Api'
import history, { logout } from '../../../../history'
import { toast } from 'react-toastify'
import { showLoading, hideLoading } from 'react-redux-loading-bar'
import {
  GET_MONTH_WISE_DAILY_TRANSACTION_SUMMARY,
  RESET_MONTH_WISE_DAILY_TRANSACTION_SUMMARY,
} from '../../../../Types'

export const getMonthWiseDailyTransactionsSummary =
  (requestData) => async (dispatch) => {
    dispatch(showLoading())
    await axios
      .post(`api/Reports/GetMonthlyDigitalTransactionSummary`, requestData)
      .then(({ data }) => {
        if (data && data?.response) {
          dispatch({
            type: GET_MONTH_WISE_DAILY_TRANSACTION_SUMMARY,
            payload: {
              data: data.response.data,
              totalRecords: data.response.totalRecords
            },
          })
        }
        dispatch(hideLoading())
      })
      .catch(function (error) {
        dispatch(hideLoading())
        if (error.response) {
          if (error.response.status === 401) {
            logout()
            history.push('/login')
            history.go('/login')
          } else if (error.response.data)
            toast.error(error.response.data.Message)
          else toast.error('Error while processing the request')
        }
      })
  }

export const resetMonthWiseDailyTransactionsSummary =
  () => async (dispatch) => {
    dispatch({
      type: RESET_MONTH_WISE_DAILY_TRANSACTION_SUMMARY
    })
  }

export const exportReport = (requestData) => async (dispatch) => {
  dispatch(showLoading());

  try {
    const { data } = await axios.post(
      `api/Reports/GetMonthlyDigitalTransactionSummary`,
      requestData
    );

    const outputFilename = `Monthly_Transactions_Report_${Date.now()}`;
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";

    const exportToExcel = (jsonData, fileName) => {
      const ws = XLSX.utils.json_to_sheet(jsonData);

      if (ws && ws["!ref"]) {
        const range = XLSX.utils.decode_range(ws["!ref"]);

        // ✅ Header Mapping (NEW MODEL)
        const headerMap = {
          DistributorCenter: "Distributor Center",
          DistributorName: "Distributor",
          Month: "Month",
          VizShops: "VIZ Shops",
          DistShops: "Distributor Shops",
          TotalOrders: "Total Orders",
          TotalOrderValues: "Total Order Values",
          TotalTransactedOrders: "Total Transacted Orders",
          TotalTransactions: "Total Transactions",
          TotalVolumeTransacted: "Total Volume Transacted",
          TotalVizshopsTransacted: "Total VIZ Shops Transacted",
          OrderConversion: "Order Conversion",
          VolumeConversion: "Volume Conversion",
          ReportDate: "Report Date",
        };

        // ✅ Replace headers dynamically
        for (let C = range.s.c; C <= range.e.c; ++C) {
          const address = XLSX.utils.encode_col(C) + "1";
          if (!ws[address]) continue;

          const originalHeader = ws[address].v;
          ws[address].v =
            headerMap[originalHeader] || originalHeader;
        }
      }

      const wb = {
        Sheets: { Sheet1: ws },
        SheetNames: ["Sheet1"], // ✅ FIXED
      };

      const excelBuffer = XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
      });

      const fileData = new Blob([excelBuffer], { type: fileType });

      fileSaver.saveAs(fileData, fileName + fileExtension);
    };

    exportToExcel(data.response.data, outputFilename);

    dispatch(hideLoading());
  } catch (error) {
    dispatch(hideLoading());

    if (error.response) {
      if (error.response.status === 401) {
        logout();
        history.push("/login");
      } else if (error.response.data) {
        toast.error(
          error.response.data.Message ||
            error.response.data.message
        );
      } else {
        toast.error("Error while processing the request");
      }
    }
  }
};
